import { getMonthToDateRange } from '@/utils/date';
import {
  parseActiveStatusFilter,
  parseNumberFilter,
  toActiveStatusFilterText,
  toFilterText,
  toPeriodFilterValues,
  toPeriodSearch,
} from '@/utils/filters';
import type { SystemDashboardSearch } from '../types/dashboard.types';

export const REPORTING_MEMBER_FILTER_KEY = 'amUserId';

export function toReportingPeriodFilterValues(
  search: SystemDashboardSearch,
): Record<string, string> {
  return {
    ...toPeriodFilterValues(search, getMonthToDateRange()),
    isActive: toActiveStatusFilterText(search.isActive),
    [REPORTING_MEMBER_FILTER_KEY]: toFilterText(search.amUserId),
  };
}

export function toReportingPeriodFilterSearch(
  values: Record<string, string>,
): SystemDashboardSearch {
  return {
    ...toPeriodSearch(values),
    isActive: parseActiveStatusFilter(values.isActive),
    amUserId: parseNumberFilter(values[REPORTING_MEMBER_FILTER_KEY]),
  };
}
